/* eslint-disable */
import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import { MaterialReactTable } from "material-react-table";
import * as XLSX from "xlsx";
import { Link } from "react-router-dom";
//import translation function for language translation
import { useTranslation } from "react-i18next";
import AddUpdateCategoryPopup from "../Popup/AddUpdateCategoryPopup";
//api url requirement
import * as url from "urlhelpers/UrlHelper";
import { getData } from "utils/Gateway";
//import context
import { GlobalProvider } from "context/GlobalContext";

const FIELD_TO_PARAM = {
  name: "name",
  slug: "slug",
  parentname: "parentname",
};

const CategoryList = ({
  downloadExcel,
  reloadCategoryList,
  setreloadCategoryList,
  checkedRecordCount,
  setRecords,
  search,
}) => {
  const token = localStorage.getItem("token");
  const { screenHeight, setSuccess, setNotificationString, setError } =
    useContext(GlobalProvider);
  const [categoryList, setCategoryList] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);
  const { t } = useTranslation(); //for translation
  const [updateCategoryData, setUpdateCategoryData] = useState(false);
  const [rowSelection, setRowSelection] = useState({});
  const [columnFilters, setColumnFilters] = useState([]);
  const columnFilterTimer = useRef(null);

  const getSelectedData = () => {
    const selectedIds = Object.keys(rowSelection).filter((key) => rowSelection[key]);
    return categoryList.filter((item) => selectedIds.includes(item._id));
  };

  const exportExcel = () => {
    const selectedData = getSelectedData();
    const exportData = selectedData.length > 0 ? selectedData : categoryList;
    const rows = exportData.map((item) => ({
      [t("Name")]: item.name || "",
      [t("Slug")]: item.slug || "",
      [t("Parent")]: item.parentname || "",
    }));
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Categories");
    XLSX.writeFile(wb, "Categories.xlsx");
  };

  const getAllCategory = async (currentColumnFilters = columnFilters) => {
    try {
      let requestUrl =
        url.API_BASEURL + url.API_GET_CATEGORIES + `?token=${token}`;
      currentColumnFilters.forEach(({ id, value }) => {
        const param = FIELD_TO_PARAM[id];
        if (param && value?.toString().trim()) {
          requestUrl += `&${param}=${encodeURIComponent(value.toString().trim())}`;
        }
      });
      console.log("url of category list------>", requestUrl);
      const response = await getData(requestUrl);
      console.log("response in category------>", response);
      if (response.status) {
        setRecords(response.data.length);
        setCategoryList(response.data);
        setResponseReceived(true);
        setNotificationString("Category list fetched successfully");
        setSuccess(true);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  /* custom title html */
  const titleHtml = ({ dataItem }) => {
    return (
      <div className="d-flex align-items-center gap-2">
        <span>{dataItem.name}</span>
        <Link
          to="#addCategoryPopup"
          data-bs-toggle="offcanvas"
          className="ml-auto edit_icon"
          onClick={() => {
            setUpdateCategoryData(dataItem);
          }}
        >
          <span className="d-block material-symbols-outlined icon-md">
            edit
          </span>
        </Link>
      </div>
    );
  };

  const tableColumns = useMemo(
    () => [
      {
        id: "name",
        accessorKey: "name",
        header: t("Name"),
        Cell: ({ row }) => titleHtml({ dataItem: row.original }),
        size: 200,
      },
      {
        id: "slug",
        accessorKey: "slug",
        header: t("Slug"),
        size: 200,
      },
      {
        id: "parentname",
        accessorKey: "parentname",
        header: t("Parent"),
        size: 200,
      },
    ],
    [categoryList, t]
  );

  useEffect(() => {
    if (reloadCategoryList) {
      getAllCategory();
      setreloadCategoryList(false);
    }
  }, [reloadCategoryList]);

  useEffect(() => {
    getAllCategory();
  }, []);

  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  /* column filter — debounced API call */
  useEffect(() => {
    clearTimeout(columnFilterTimer.current);
    columnFilterTimer.current = setTimeout(() => {
      getAllCategory(columnFilters);
    }, 500);
  }, [columnFilters]);

  /* sync selected count to parent */
  useEffect(() => {
    const selectedCount = Object.keys(rowSelection).filter((key) => rowSelection[key]).length;
    checkedRecordCount(selectedCount);
  }, [rowSelection, categoryList]);

  return (
    <div className="table-responsive">
      <MaterialReactTable
        columns={tableColumns}
        data={categoryList}
        enableSorting
        enableFilters
        enableGlobalFilter={false}
        manualFiltering
        enableGrouping
        enableColumnOrdering
        enableStickyHeader
        enableRowSelection
        onRowSelectionChange={setRowSelection}
        onColumnFiltersChange={setColumnFilters}
        getRowId={(row) => row._id}
        state={{ rowSelection, columnFilters }}
        muiTableContainerProps={{ sx: { maxHeight: screenHeight || "70vh" } }}
        muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
        muiTableBodyProps={{ sx: { overflow: "visible" } }}
        initialState={{
          pagination: { pageSize: 100, pageIndex: 0 },
          showColumnFilters: true,
        }}
      />
      {/* ------ addupdate popup ----- */}
      <AddUpdateCategoryPopup
        setUpdateCategoryData={setUpdateCategoryData}
        updateCategoryData={updateCategoryData}
        setreloadCategoryList={setreloadCategoryList}
      />
    </div>
  );
};
export default CategoryList;
